<template>
    <div>
        <v-list two-line subheader style="padding-bottom:0;border-radius:10px;overflow: hidden;">
            <v-subheader style="height:2rem;padding-top:0.5rem;font-weight:bold;font-size:1.05rem;margin-top:0.1rem;">
              <v-row style="margin-top:0.7rem;">
                <v-col :cols="8" style="padding-left:0.56rem;">
                  <span style="color:rgba(33,33,33,0.9);">企业</span>
                </v-col>
              </v-row>
            </v-subheader>
            <LoadingText style="margin:3rem 0;" v-if="loading" />
            <div v-else style="margin-top:1rem;">
              <div v-for="(item,index) in entList" :key="index">
                <v-list-item style="padding-left:1.53rem;padding-bottom:0.5rem;padding-right:0.25rem;" @click="goEntInfo(item)">
                    <v-list-item-content style="padding:0.5rem 0 0.2rem;">
                      <v-list-item-title style="font-size:0.95rem;padding:0.3rem 0 0;">
                        <v-row style="margin:0">
                          <v-col :cols="12" style="padding:0;position:relative;" >
                            <v-icon style="position:absolute;left:1.5px;top:0.05rem;color:#9e9e9e;font-size: 16px;">mdi-film</v-icon>
                            <span style="margin-left:1.2rem;overflow:auto;display:inline-block;word-wrap:break-word;white-space:normal;">{{item.COMPANY_NAME}}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                      <v-list-item-subtitle style="margin-bottom:0.3rem;padding-left:1.2rem;" v-if="false">
                        <span>
                          <v-chip v-if="item.STAFF_ROLE === 'admin'" small label class="warning--text" color="#FFF8E1" style="padding:0 0.6rem;">
                            管理员
                          </v-chip>
                          <v-chip v-else small class="primary--text" label color="#E3F2FD" style="padding:0 0.6rem;">
                            成员
                          </v-chip>
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle style="font-size:0.72rem;padding-left:1.2rem;">
                        加入时间：{{$moment(item.JOIN_DATE).format('YYYY-MM-DD HH:mm')}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon style="margin:0;">
                      <v-icon color="grey" style="margin-top:1.45rem;">fa fa-angle-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>
                <v-divider style="border-color:#f2f2f2;" v-if="index < entList.length-1" />
              </div>
              <div v-if="entList.length === 0" style="text-align:center;color:#9e9e9e;font-size:0.8rem;margin:0.6rem 0;padding-bottom:0.5rem;">
                还没有加入企业
              </div>
            </div>
            <v-subheader style="height:2rem;padding-top:0.5rem;font-weight:bold;font-size:1.05rem;">
              <v-row style="margin-top:0.7rem;">
                <v-col :cols="8" style="padding-left:0.56rem;">
                  <span style="color:rgba(33,33,33,0.9);">我的团队</span>
                </v-col>
                <v-col :cols="4" style="text-align:right;">
                  <!-- <v-row style="margin:0;" no-gutters>
                    <v-col :cols="5" style="padding:0;text-align:right;padding-right:0.2rem;">
                      <span @click="goCreateCompany"><i class="fa fa-plus-square-o" aria-hidden="true" style="margin-top:0.35rem;"></i></span>
                    </v-col>
                    <v-col :cols="7" style="padding:0;" @click="goCreateCompany">
                      <span style="font-size:0.8rem;">创建团队</span>
                    </v-col>
                  </v-row> -->
                  <span style="display:inline-block;margin-right:0.3rem;position:relative;cursor: pointer;" @click="goCreateCompany">
                    <i class="fa fa-plus-square-o" aria-hidden="true" style="position:absolute;right:0;top:-0.76rem;" />
                  </span>
                  <span style="font-size:0.85rem;cursor: pointer;" @click="goCreateCompany">创建团队</span>
                </v-col>
              </v-row>
            </v-subheader>
            <LoadingText style="margin:3rem 0;" v-if="loading" />
            <div v-else style="margin-top:1rem;">
              <div v-for="(item,index) in list" :key="index">
                <v-list-item style="padding-left:1.53rem;padding-bottom:0.5rem;padding-right:0.25rem;" @click="goCompanyInfo(item)">
                    <v-list-item-content style="padding:0.5rem 0 0.2rem;">
                      <v-list-item-title style="font-size:0.95rem;padding:0.3rem 0 0;">
                        <v-row style="margin:0">
                          <v-col :cols="12" style="padding:0;position:relative;" >
                            <v-icon style="position:absolute;left:1.5px;top:0.05rem;color:#9e9e9e;font-size: 16px;">mdi-account-multiple</v-icon>
                            <span style="margin-left:1.2rem;overflow:auto;display:inline-block;word-wrap:break-word;white-space:normal;">{{item.COMPANY_NAME}}</span>
                          </v-col>
                          <!-- <v-col :cols="4" style="padding:0;text-align:right;padding-right:0.2rem;" @click="goInvite(item)" v-if="item.STAFF_ROLE === 'admin' && false">
                            <span style="display:inline-block;"><i class="fa fa-user-plus" aria-hidden="true" style="margin-right:0.3rem;color:#9e9e9e;"></i></span>
                            <span style="font-size:0.85rem;">邀请</span>
                          </v-col> -->
                        </v-row>
                      </v-list-item-title>
                      <v-list-item-subtitle style="margin-bottom:0.3rem;padding-left:1.2rem;" v-if="false">
                        <span>
                          <v-chip v-if="item.STAFF_ROLE === 'admin'" small label class="warning--text" color="#FFF8E1" style="padding:0 0.6rem;">
                            管理员
                          </v-chip>
                          <v-chip v-else small class="primary--text" label color="#E3F2FD" style="padding:0 0.6rem;">
                            团员
                          </v-chip>
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle style="font-size:0.72rem;padding-left:1.2rem;">
                        创建时间：{{$moment(item.ROW_DATE_CREATE).format('YYYY-MM-DD HH:mm')}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon style="margin:0;">
                      <v-icon color="grey" style="margin-top:1.45rem;">fa fa-angle-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>
                <v-divider style="border-color:#f2f2f2;" />
              </div>
              <div v-if="list.length === 0" style="text-align:center;color:#9e9e9e;font-size:0.8rem;margin:0.6rem 0;">
                暂无团队
              </div>
            </div>
            <v-subheader style="height:2rem;padding-top:0.5rem;font-weight:bold;font-size:1.05rem;margin-top:0.1rem;">
              <v-row style="margin-top:0.7rem;">
                <v-col :cols="8" style="padding-left:0.56rem;">
                  <span style="color:rgba(33,33,33,0.9);">加入的团队</span>
                </v-col>
              </v-row>
            </v-subheader>
            <LoadingText style="margin:3rem 0;" v-if="loading" />
            <div v-else style="margin-top:1rem;">
              <div v-for="(item,index) in list2" :key="index">
                <v-list-item style="padding-left:1.53rem;padding-bottom:0.5rem;padding-right:0.25rem;" @click="goCompanyInfo(item)">
                    <v-list-item-content style="padding:0.5rem 0 0.2rem;">
                      <v-list-item-title style="font-size:0.95rem;padding:0.3rem 0 0;">
                        <v-row style="margin:0">
                          <v-col :cols="12" style="padding:0;position:relative;" >
                            <v-icon style="position:absolute;left:1.5px;top:0.05rem;color:#9e9e9e;font-size: 16px;">mdi-account-multiple</v-icon>
                            <span style="margin-left:1.2rem;overflow:auto;display:inline-block;word-wrap:break-word;white-space:normal;">{{item.COMPANY_NAME}}</span>
                          </v-col>
                          <!-- <v-col :cols="4" style="padding:0;text-align:right;padding-right:0.2rem;" @click="goInvite(item)" v-if="item.STAFF_ROLE === 'admin' && false">
                            <span style="display:inline-block;"><i class="fa fa-user-plus" aria-hidden="true" style="margin-right:0.3rem;color:#9e9e9e;"></i></span>
                            <span style="font-size:0.85rem;">邀请</span>
                          </v-col> -->
                        </v-row>
                      </v-list-item-title>
                      <v-list-item-subtitle style="margin-bottom:0.3rem;padding-left:1.2rem;" v-if="false">
                        <span>
                          <v-chip v-if="item.STAFF_ROLE === 'admin'" small label class="warning--text" color="#FFF8E1" style="padding:0 0.6rem;">
                            管理员
                          </v-chip>
                          <v-chip v-else small class="primary--text" label color="#E3F2FD" style="padding:0 0.6rem;">
                            团员
                          </v-chip>
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle style="font-size:0.72rem;padding-left:1.2rem;">
                        加入时间：{{$moment(item.JOIN_DATE).format('YYYY-MM-DD HH:mm')}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon style="margin:0;">
                      <v-icon color="grey" style="margin-top:1.45rem;">fa fa-angle-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>
                <v-divider style="border-color:#f2f2f2;" v-if="index < list2.length-1" />
              </div>
              <div v-if="list2.length === 0" style="text-align:center;color:#9e9e9e;font-size:0.8rem;margin:0.6rem 0;padding-bottom:0.5rem;">
                还没有加入团队
              </div>
            </div>
        </v-list>
    </div>
</template>

<script>
import LoadingText from '../../components/LoadingText'
export default {
  components: {
    LoadingText
  },
  props: {
  },
  data() {
    return {
      list: [],
      list2: [],
      entList: [],
      shareExpiry: 10,
      loading: true,
      selfInfo: {}
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    var that = this
    that.selfInfo = that.$AppHelper.getUserInfo()
    that.getCompanyList();
  },
  activated() {
    var that = this
    if (that.$router.isBack) {
      that.getCompanyList();
    }
  },
  methods: {
    async getCompanyList() {
      var that = this
      var res = await that.$api.bz.getCompanyList()
      // console.log('getCompanyList.res', res);
      if (!res.success) {
        // that.$toast.error('获取团队列表失败')
        console.log('获取团队列表失败', res);
        return
      }
      var data = res.data
      that.list = []
      that.list2 = []
      that.entList = []
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        if (item.PARTY_TYPE === 'ENT') {
          that.entList.push(item)
          continue
        }
        if (item.ADMIN_CODE && item.ADMIN_CODE === that.selfInfo.usercode) {
          that.list.push(item)
        } else {
          that.list2.push(item);
        }
      }
      that.loading = false
    },
    // goInvite(item) {
    //   var that = this
    //   that.$api.bz.createCompanyInvite({ company_code: item.COMPANY_CODE, invite_expiry: that.shareExpiry, s_role: that.role }).then(res => {
    //     // console.log('生成企业邀请码', res)
    //     if (!res.success) {
    //       // that.$toast.error('生成团队邀请码失败')
    //       console.log('生成团队邀请码失败', res);
    //       return
    //     }
    //     var data = res.data
    //     that.$router.goPage({ path: '/CompanyInvite', query: { code: item.COMPANY_CODE, name: item.COMPANY_NAME, qrcode: data, expiry: that.shareExpiry }})
    //   })
    // },
    goCreateCompany() {
      var that = this
      that.$api.bz.meetCreateCompanyCondition().then(res => {
        if (!res.success) {
          that.$toast.warning(res.error_msg ? res.error_msg : '不满足创建团队条件')
          return
        }
        that.$router.goPage('/CreateCompany');
      })
    },
    goCompanyInfo(item) {
      this.$router.goPage({ path: '/CompanyInfo', query: { code: item.COMPANY_CODE }})
    },
    goEntInfo(item) {
      this.$router.goPage({ path: '/EntInfo', query: { code: item.COMPANY_CODE }})
    }
  }
}
</script>

<style scoped>
</style>
